export class MachineTileValueItemDetails {
  isValueMissing: boolean = true;
  label: string = '';
  value: string = '';
  signalName: string = '';
  hasEnhancedDetails: boolean = false;
  enhancedDetailsBody: string | null = null;
  enhancedDetailsTitle: string = '';
}
